import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// json's de traducciones
import Home from './translates/Home.json';
import Article from './translates/Article.json';
import RiskWarning from './translates/riskWarning.json';

const resources = {
  en: {
    home: Home.en,
    article: Article.en,
    riskWarning: RiskWarning.en,
  },
  es: {
    home: Home.es,
    article: Article.es,
    riskWarning: RiskWarning.es,
  },
  pt: {
    home: Home.pt,
    article: Article.pt,
    riskWarning: RiskWarning.pt,
  },
  fr: {
    home: Home.fr,
    article: Article.fr,
    riskWarning: RiskWarning.fr,
  },
  it: {
    home: Home.it,
    article: Article.it,
    riskWarning: RiskWarning.it,
  },
  zh: {
    home: Home.zh,
    article: Article.zh,
    riskWarning: RiskWarning.zh,
  },
};

// Obtener el idioma inicial desde la URL
const getInitialLanguage = () => {
  const pathLang = window.location.pathname.split('/')[1];
  return ['en', 'es', 'pt', 'fr', 'it', 'zh'].includes(pathLang) ? pathLang : 'en'; // Si no es un idioma válido, usar 'en'
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(), // Establecer el idioma inicial desde la URL
    fallbackLng: 'en',
    ns: ['home', 'article', 'riskWarning'], // Definir los namespaces disponibles
    defaultNS: 'home',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
